/* globals angular */
(function() {
  "use strict";

  function IntegrationResource($resource, PUBLIC_API, URLAPIPEDIDO) {
    return $resource(
      PUBLIC_API,
      {},
      {
        isAuthorized: {
          method: "GET",
          url: PUBLIC_API + "/plataformas/:provider/autorizacao",
          params: {
            provider: "@provider"
          }
        },
        authorize: {
          method: "POST",
          url: PUBLIC_API + "/plataformas/:provider/autorizacao",
          params: {
            provider: "@provider"
          }
        },
        disconnect: {
          method: "DELETE",
          url: PUBLIC_API + "/plataformas/:provider/autorizacao",
          params: {
            provider: "@provider"
          }
        },
        getTransactions: {
          method: "GET",
          url: PUBLIC_API + "/plataformas/:provider/pedidos",
          params: {
            provider: "@provider",
            dataInicio: "@dataInicio",
            dataFim: "@dataFim",
            pagina: "@pagina",
            status: "@status"
          }
        },
        getTransactionsTrayCorp: {
          method: "GET",
          url: PUBLIC_API + "/plataformas/:provider/pedidos",
          params: {
            provider: "@provider",
            dataInicio: "@dataInicio",
            dataFim: "@dataFim",
            pagina: "@pagina",
            status: "@status"
          }
        },
        validate: {
          method: "POST",
          url: URLAPIPEDIDO + "/v1/vendas/validar"
        },
        createOrder: {
          method: "POST",
          url: URLAPIPEDIDO + "/v1/vendas/:provider?canal=webapp_integracao"
        },
        orderStatus: {
          method: "GET",
          url: PUBLIC_API + "/plataformas/:provider/mapeamentos/status-pedido",
          params: {
            provider: "@provider"
          }
        },
        setOrderStatus: {
          method: "POST",
          url: PUBLIC_API + "/plataformas/:provider/mapeamentos/status-pedido",
          params: {
            provider: "@provider"
          }
        },
        saveAutoDeliveryType: {
          method: "POST",
          url: PUBLIC_API + "/plataformas/:provider/mapeamentos/de-para",
          params: {
            provider: "@provider"
          }
        },
        defineSequenceVTEX: {
          method: "POST",
          url:
            PUBLIC_API +
            "/plataformas/:provider/mapeamentos/mapear-sequence-no-campo-referencia",
          params: {
            provider: "@provider"
          }
        },
        getSequenceVTEX: {
          method: "GET",
          url:
            PUBLIC_API +
            "/plataformas/:provider/mapeamentos/mapear-sequence-no-campo-referencia",
          params: {
            provider: "@provider"
          }
        },
        getConfigs: {
          method: "GET",
          url:
            PUBLIC_API +
            "/configuracao/ativacao?plataforma=:plataforma&cliente=:cliente",
          params: {
            plataforma: "@plataforma",
            cliente: "@cliente"
          }
        },
        defineConfigs: {
          method: "POST",
          url: PUBLIC_API + "/configuracao/ativacao"
        },
        getAutoDeliveryType: {
          method: "GET",
          url: PUBLIC_API + "/plataformas/:provider/mapeamentos/de-para",
          params: {
            provider: "@provider"
          }
        },
        removeAutoDeliveryType: {
          method: "POST",
          url:
            PUBLIC_API + "/plataformas/:provider/mapeamentos/de-para/remover",
          params: {
            provider: "@provider"
          }
        },
        saveAutoInsurance: {
          method: "POST",
          url:
            PUBLIC_API +
            "/plataformas/:provider/mapeamentos/preenche-valor-declarado",
          params: {
            provider: "@provider"
          }
        },
        getAutoInsurance: {
          method: "GET",
          url:
            PUBLIC_API +
            "/plataformas/:provider/mapeamentos/preenche-valor-declarado",
          params: {
            provider: "@provider"
          }
        },
        authorizeBatch: {
          method: "POST",
          url: PUBLIC_API + "/plataformas/autorizacao/lote"
        }
      }
    );
  }

  angular
    .module("mandaeApp")
    .factory("IntegrationResource", IntegrationResource);
})();
